import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectionStatus, SocketService } from '../../services/socket.service';

@Component({
    selector: 'vb-connection-status',
    templateUrl: './connection-status.component.html',
    styleUrls: ['./connection-status.component.scss'],
})
export class ConnectionStatusComponent implements OnInit, OnDestroy {
    public status: ConnectionStatus = 'disconnected';

    /** The lazy socket starts 'disconnected' on every page load while the
     *  first handshake is still in flight — warning about that is just boot
     *  noise. Show the banner only once the session has connected, or after
     *  a grace period when the first connect never lands (a real outage). */
    private hasConnected: boolean = false;
    private bootGraceOver: boolean = false;
    private graceTimer: ReturnType<typeof setTimeout> | null = null;

    private subscription: Subscription = new Subscription();

    constructor(private socketService: SocketService) {}

    ngOnInit(): void {
        this.graceTimer = setTimeout(() => {
            this.bootGraceOver = true;
        }, 10_000);
        this.subscription.add(
            this.socketService.connectionStatus$.subscribe(
                (status: ConnectionStatus) => {
                    if (status === 'connected') {
                        this.hasConnected = true;
                    }
                    this.status = status;
                },
            ),
        );
    }

    get visible(): boolean {
        return (
            (this.hasConnected || this.bootGraceOver) &&
            this.status !== 'connected'
        );
    }

    /** Full page refresh: while disconnected the page has missed socket
     *  updates, so reconnecting alone would leave stale prices/outcomes on
     *  screen — reload to re-establish the socket AND re-fetch state. */
    public refresh(): void {
        window.location.reload();
    }

    ngOnDestroy(): void {
        if (this.graceTimer) {
            clearTimeout(this.graceTimer);
        }
        this.subscription.unsubscribe();
    }
}
